<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Api Keys" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section id="page-api-keys">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="media mb-2">
                    <h2>API Keys</h2>
                  </div>
                  <div class="row">
                    <div class="col-8">
                      <div class="form-group">
                        <label>Client ID</label>
                        <input
                            class="form-control"
                            type="text"
                            v-model="clientId"
                            disabled
                        >
                      </div>
                    </div>
                    <div class="col-2">
                      <label></label>
                      <div class="form-group">
                        <div class="badge badge-glow badge-pill badge-primary btn mt-1" @click="copyText(clientId)"><BIconJournalText  class="" /> Copy!</div>
                      </div>
                    </div>
                    <div class="col-8">
                      <div class="form-group">
                        <label>Client Secret</label>
                        <input
                            class="form-control"
                            type="text"
                            v-model="clientSecret"
                            disabled
                        >
                      </div>
                    </div>
                    <div class="col-2">
                      <label></label>
                      <div class="form-group">
                        <div class="form-group">
                          <div class="badge badge-glow badge-pill badge-primary btn mt-1" @click="copyText(clientSecret)"><BIconJournalText class="" /> Copy!</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import {useToast} from "vue-toastification";
import ToastificationContent from "@/components/common/ToastificationContent.vue";

export default {
  mounted() {
    this.getMerchantAppSettings()
  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Api Keys'},
      ],
      clientSecret: '',
      clientId:'',
      toastG : useToast(),
    }
  },
  methods: {
    copyText(text) {
      navigator.clipboard.writeText(text);
      this.toastG({
        component: ToastificationContent,
        props: {
          title: 'Text Copied',
          icon: 'BellIcon',
          text: text,
          variant:'success',
        },
      })
    },
    getMerchantAppSettings() {
      this.makeRequest('post', 'v1/get-merchant-app-settings', {},{},false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let data = callResponse.response.data.data
            if(typeof(data[0]) != 'undefined'){
              this.clientId = data[0].client_id
              this.clientSecret = data[0].client_secret
            }
          }
        }
      });
    },
  },
}
</script>
